import queryString from "query-string";

const getEnabledFeatures = state =>
  queryString.parse(state.router.location.search, { arrayFormat: "bracket" })
    ?.enabledFeatures ?? [];

export default getEnabledFeatures;
